import { useDeletePhonecentersMaintenance } from "./api/deletePhonecentersMaintenance";
import { Button } from "reactstrap";


const DeletePhonecentersMaintenance = ({handleCloseModal, phonecentersMaintenanceId}: DeletePhonecentersMaintenanceProps)  => {
  
  const deletePhonecentersMaintenanceMutation = useDeletePhonecentersMaintenance({ phonecentersMaintenanceId});
  const handleSubmit = async (): Promise<void> => {
    deletePhonecentersMaintenanceMutation.mutateAsync({ 
      phonecentersMaintenanceId: phonecentersMaintenanceId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τον Συντηρητή;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePhonecentersMaintenanceProps{
  phonecentersMaintenanceId: number;
  handleCloseModal: () => void;
}

export default DeletePhonecentersMaintenance;